import { createTheme, lighten } from '@mui/material/styles'
import { grey } from '@mui/material/colors'
import { sharedTheme } from './shared-theme'

export const modellingTheme = createTheme({
  palette: {
    primary: {
      main: '#006286',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#00A3E0',
      contrastText: '#FFFFFF',
    },
    success: {
      main: '#4caf50',
      contrastText: '#FFFFFF',
    },
    info: {
      main: '#2196f3',
      contrastText: '#FFFFFF',
    },
    warning: {
      main: '#ff9800',
      contrastText: '#FFFFFF',
    },
    error: {
      main: lighten('#f44336', 0.3),
      contrastText: '#FFFFFF',
    },
    action: {
      hover: lighten('#006286', 0.9),
    },
    grey: grey, // full grey color palette from MUI
    tonalOffset: 0.2,
    ...sharedTheme.palette, // merged shared palette overrides
  },
  // @ts-ignore
  borders: {
    grey: grey[300],
  },
  typography: {
    ...sharedTheme.typography,
  },
})
